export default __webpack_public_path__ + "static/media/TERMO_DE_USO_OKAPP.bbf7ccca.pdf";